import { render, staticRenderFns } from "./Prototype.vue?vue&type=template&id=353f9e91&scoped=true"
import script from "./Prototype.vue?vue&type=script&lang=js"
export * from "./Prototype.vue?vue&type=script&lang=js"
import style0 from "./Prototype.vue?vue&type=style&index=0&id=353f9e91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f9e91",
  null
  
)

export default component.exports